import { createContext } from 'react';
import { ConnectionType } from './connectionTypes';

const connectionContext = createContext({} as ConnectionType);
connectionContext.displayName = 'ConnectionContext';

export default connectionContext;
